<div class="container" *ngIf="authService.loggedUser">
  <div class="content">
    <img class="logo" src="assets/icons/tc_logo.svg" alt="Logo" />
    <p class="title">Vas a continuar el registro en Manteca</p>
    <p class="text-secondary">
      Vamos a redireccionarte para que completes todos tus datos, luego regresarás a TiendaCrypto.
    </p>
    <img class="redirect" src="assets/images/redirect.svg" alt="Redirect" />
    <div class="footer">
      <p class="text" (click)="utils.openTyc()">Términos y Condiciones</p>
      <p class="text">© TiendaCrypto {{ actualYear }}</p>
    </div>
  </div>
</div>
